export default [
  {
    key: "requestPlatformCodes",
    rules: {
      isRequired: true,
    }
  },
]

